module.exports = __webpack_public_path__ + "static/media/preview.3ffe0420.png";